const constants = {
  API_URL: process.env.API_URL,
  DOMAIN_URL: process.env.DOMAIN_URL
};

module.exports = constants;
